import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-onboarding-investor-avatar',
  templateUrl: './onboarding-investor-avatar.component.html',
  styleUrls: ['./onboarding-investor-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingInvestorAvatarComponent {
  @Input() isEntity = false;
}
